import React from "react";
import Textfield from "Components/UI/Form/Textfield";
import { systemStatusOptions } from "utils/options/systemStatusOptions";

import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";


export default function EndcustomerArticleFormSystem({
  formData,
  handleInputChange,
}) {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield
            disabled
            label="Kontrollstatus"
            value={formData.ParseStatus}
            onChange={(e) => handleInputChange("ParseStatus", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield
            disabled
            label="Kontrollmeddelande"
            value={formData.ParseMessage}
            onChange={(e) => handleInputChange("ParseMessage", e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <FormControl margin="dense" fullWidth sx={{ textAlign: "left" }}>
            <InputLabel>Status</InputLabel>
            <Select
              name="SystemStatus"
              value={formData.SystemStatus}
              onChange={(e) =>
                handleInputChange("SystemStatus", e.target.value)
              }
              label="Status"
              size="small"
            >
              {systemStatusOptions.map((option) => (
                <MenuItem key={option.Value} value={option.Value}>
                  {option.Name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield
            disabled
            name="Skapad"
            label="Skapad"
            value={formData.CreateTime}
            format="YYYY-MM-DD"
            slotProps={{
              textField: { size: "small", fullWidth: true, margin: "dense" },
            }}
          />
        </Grid>
      </Grid>
    </>
  );
}
